import { render, staticRenderFns } from "./InvoiceElement.vue?vue&type=template&id=65d1f575&scoped=true&"
import script from "./InvoiceElement.vue?vue&type=script&lang=js&"
export * from "./InvoiceElement.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceElement.vue?vue&type=style&index=0&id=65d1f575&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d1f575",
  null
  
)

export default component.exports